import React, { useCallback, useEffect, useState } from 'react';
import { Button, OutlinedInput } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { notif } from '../../utils/util';
import { FaDownload, FaSave, FaTimes, FaUpload } from 'react-icons/fa';
import { useDropzone } from 'react-dropzone';
import '../../../App.css';
import {
  DataGrid,
  GridColDef,
  GridValueGetterParams,
  GridEventListener,
} from '@mui/x-data-grid';
import {
  getInventoryStatus,
  getVendors,
  uploadInventory,
} from '../../../server/server';
import Spinner from '../../utils/Spinner';
import { LoadingButton } from '@mui/lab';

function InventoryScreen() {
  const [file, setFile] = useState<any>();
  const [statusVendors, setStatusVendors] = useState<any>([]);
  const [csvData, setCsvData] = useState<any>([{ SKU: '', Quantity: '' }]);
  const [uploadingLoading, setUploadingLoading] = useState(false);
  const [statsLoading, setStatsLoading] = useState(true);
  const [selColumns, setSelColumns] = useState({
    SKU: '',
    Quantity: '',
  });
  const [vendors, setVendors] = useState<Vendor[]>([]);
  const [currentVendor, setCurrentVendor] = useState<Vendor>();
  const onDrop = useCallback(
    (acceptedFiles: any) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const PapaPromise = import('papaparse');

      const reader = new FileReader();
      reader.onload = async function (e) {
        const rawData = e.target?.result as string;

        const Papa = await PapaPromise;
        const { data } = Papa.parse(rawData, {
          header: true,
        });
        setCsvData(data);
      };

      setFile(acceptedFiles[0]);
      reader.readAsText(acceptedFiles[0]);
    },
    [file]
  );

  const columns: GridColDef[] = [
    { field: selColumns?.SKU, headerName: 'SKU', width: 280 },
    { field: selColumns?.Quantity, headerName: 'Quantity', width: 200 },
  ];
  const { acceptedFiles, fileRejections, getRootProps, getInputProps } =
    useDropzone({
      onDrop,
      accept: {
        'text/csv': [],
      },
    });
  const uploadFile = async () => {
    setUploadingLoading(true);
    console.log(selColumns);
    const resp = await uploadInventory(file, selColumns, currentVendor?.id);

    if (resp?.status === 201) {
      setUploadingLoading(false);
      notif('File successfully uploaded', 'success');
      removeFile();
      setStatsLoading(true);
      loadStatus();
    } else {
      notif('File not uploaded', 'error');
    }
  };
  const removeFile = () => {
    setFile(null);
    setSelColumns({
      SKU: '',
      Quantity: '',
    });
    setCurrentVendor(undefined);
  };
  type Vendor = {
    [key: string]: any;
    id?: string;
    name?: string;
  };
  const handleChange = (e: SelectChangeEvent) => {
    const vendor = vendors.find((r: Vendor) => r?.name === e.target.value);
    setCurrentVendor(vendor as any);
    if (!selColumns?.SKU && !selColumns?.Quantity) {
      setSelColumns(vendor?.prefColumns);
    }
  };

  const handleSKU = (e: SelectChangeEvent) => {
    setSelColumns({ Quantity: selColumns?.Quantity, SKU: e.target.value });
  };
  const handleQty = (e: SelectChangeEvent) => {
    setSelColumns({ SKU: selColumns?.SKU, Quantity: e.target.value });
  };
  const loadVendors = async () => {
    const resp = await getVendors('');
    if (resp?.status === 200) {
      setVendors(resp?.data);
    }
  };
  const loadStatus = async () => {
    const resp = await getInventoryStatus();
    if (resp?.status === 200) {
      setStatsLoading(false);
      setStatusVendors(resp?.data);
    }
  };

  useEffect(() => {
    loadVendors();
    loadStatus();
  }, []);

  const colorMap = (ratio: any) => {
    if (ratio < 80) {
      return 'rgba(211, 34, 46, 0.8)';
    }
    if (ratio > 90) {
      return 'rgba(33, 130, 33, 0.8)';
    } else {
      return 'rgba(245, 184, 0, 0.8)';
    }
  };
  return (
    <div className="p-6 mb-24">
      <div className="rounded-lg items-start min-w-[500px] relative  w-full  mt-8 flex justify-between mb-6">
        {statsLoading ? (
          <Spinner />
        ) : (
          <div className="mx-1 w-full">
            <h1 className="text-gray-200 text-4xl font-semibold mb-4">
              Inventory status
            </h1>
            <div className="flex flex-row items-start justify-center gap-0 flex-wrap ">
              {statusVendors.map((v: any) => {
                let ratio =
                  v?.total == 0
                    ? 0
                    : Math.round((v?.available / v?.total) * 100);
                return (
                  <div
                    key={v?.id}
                    className="text-[#dce1f4bb] flex-1 min-w-[90px] grow border-[#81848f17] border-t-2 border-b-2  border-l-2 last:border-r-2"
                  >
                    <div className="text-[12px] h-[40px] break-words px-2 justify-center items-center flex text-center text-[#dce1f4] border-[#81848f17] border-b-2">
                      {v?.name}
                    </div>
                    <div className="flex flex-row h-[35px]">
                      <div className="flex flex-col w-[50%] text-[12px]">
                        <div className="h-[50%] border-[#81848f17] border-b-2 justify-center items-center flex">
                          {v?.available}
                        </div>
                        <div className="h-[50%] justify-center items-center flex">
                          {v?.total}
                        </div>
                      </div>
                      <div
                        className={`flex flex-row justify-center text-sm text-white font-bold items-center w-[50%]`}
                        style={{
                          backgroundColor: colorMap(ratio),
                          opacity: 0.8,
                        }}
                      >
                        {ratio}%
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
      <h1 className="text-gray-200 text-4xl font-semibold">Import Inventory</h1>
      <div className="flex gap-10 w-fit">
        <div className="rounded-lg border border-[#81848f3d] min-w-[450px]  p-3 mt-8 flex justify-between">
          <div className="mx-4 w-full">
            <p className="text-gray-400 mb-6">Import new inventory</p>
            {/* <input
              className="block w-full h-[30px] file:h-[30px] text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 cursor-pointer 
          dark:text-gray-400 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400
          file:text-white file:bg-[#1565c0] file:border-0 file:cursor-pointer"
              id="file_input"
              accept=".csv"
              type="file"
            />
            <p className="text-gray-400 mt-1 text-sm" id="file_input_help">
              CSV file
            </p> */}

            {file?.path ? (
              <div className="w-full">
                <div className="text-[#dce1f4bb]">
                  <div className="flex items-center mb-6" key="1">
                    <p>{file?.path}</p>
                    <FaTimes
                      onClick={removeFile}
                      className="ml-2 fill-red-600 cursor-pointer"
                    />
                  </div>
                  <div className="flex flex-col justify-start items-start gap-3">
                    <FormControl variant="filled" sx={{ minWidth: 160 }}>
                      <InputLabel
                        id="demo-multiple-name-label"
                        sx={{ color: 'white' }}
                      >
                        Select Vendor
                      </InputLabel>
                      <Select
                        labelId="demo-multiple-name-label"
                        id="demo-simple-select-filled"
                        value={currentVendor?.name}
                        className="capitalize"
                        onChange={handleChange}
                        // input={<OutlinedInput label="Vendors" />}
                        sx={{
                          color: 'white',

                          '.MuiFilledInput-input': {
                            borderColor: 'white',
                            backgroundColor: '#0a1929',
                          },
                          '&:hover .MuiFilledInput-input': {
                            borderColor: 'white',
                          },
                          '.MuiSvgIcon-root ': {
                            fill: 'white !important',
                          },
                        }}
                      >
                        {vendors?.map((vendor: Vendor) => {
                          return (
                            <MenuItem
                              value={vendor?.name}
                              className="capitalize"
                              key={vendor?.id}
                            >
                              {vendor?.name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <FormControl variant="filled" sx={{ minWidth: 160 }}>
                      <InputLabel
                        id="demo-multiple-name-label"
                        sx={{ color: 'white' }}
                      >
                        SKU column
                      </InputLabel>
                      <Select
                        labelId="demo-multiple-name-label"
                        id="demo-simple-select-filled"
                        value={selColumns?.SKU}
                        className="capitalize"
                        onChange={handleSKU}
                        // input={<OutlinedInput label="Vendors" />}
                        sx={{
                          color: 'white',

                          '.MuiFilledInput-input': {
                            borderColor: 'white',
                            backgroundColor: '#0a1929',
                          },
                          '&:hover .MuiFilledInput-input': {
                            borderColor: 'white',
                          },
                          '.MuiSvgIcon-root ': {
                            fill: 'white !important',
                          },
                        }}
                      >
                        {Object.keys(csvData?.[0] ?? ['SKU'])?.map(
                          (item: string) => {
                            return (
                              <MenuItem
                                value={item}
                                className="capitalize"
                                key={item}
                              >
                                {item}
                              </MenuItem>
                            );
                          }
                        )}
                      </Select>
                    </FormControl>
                    <FormControl variant="filled" sx={{ minWidth: 160 }}>
                      <InputLabel
                        id="demo-multiple-name-label"
                        sx={{ color: 'white' }}
                      >
                        Quantity column
                      </InputLabel>
                      <Select
                        labelId="demo-multiple-name-label"
                        id="demo-simple-select-filled"
                        value={selColumns?.Quantity}
                        className="capitalize"
                        onChange={handleQty}
                        // input={<OutlinedInput label="Vendors" />}
                        sx={{
                          color: 'white',

                          '.MuiFilledInput-input': {
                            borderColor: 'white',
                            backgroundColor: '#0a1929',
                          },
                          '&:hover .MuiFilledInput-input': {
                            borderColor: 'white',
                          },
                          '.MuiSvgIcon-root ': {
                            fill: 'white !important',
                          },
                        }}
                      >
                        {Object.keys(csvData?.[0] ?? ['QTY'])?.map(
                          (item: string) => {
                            return (
                              <MenuItem
                                value={item}
                                className="capitalize"
                                key={item}
                              >
                                {item}
                              </MenuItem>
                            );
                          }
                        )}
                      </Select>
                    </FormControl>
                  </div>
                </div>
                <div className="mb-2 flex justify-end  items-end div-btn">
                  <LoadingButton
                    variant="contained"
                    sx={{
                      backgroundColor: '',
                      color: 'white !important',
                      '& .MuiCircularProgress-svg': { color: 'white' },
                      '& .MuiLoadingButton-root': { color: 'white' },
                      '&  .MuiLoadingButton-loading': { color: 'white' },
                    }}
                    endIcon={<FaUpload />}
                    loading={uploadingLoading}
                    loadingPosition="end"
                    onClick={uploadFile}
                  >
                    Upload
                  </LoadingButton>
                </div>
              </div>
            ) : (
              <div>
                <div
                  {...getRootProps({ className: 'dropzone' })}
                  className="cursor-pointer w-full h-28 mb-4 text-[#dce1f4bb] flex items-center justify-center p-3 border-dashed border-2 border-[#dce1f43d] rounded-xl"
                >
                  <input {...getInputProps()} multiple={false} />
                  <p>Drag 'n' drop csv file here, or click to select file</p>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* <div className="rounded-lg border border-[#81848f3d] w-[450px] mt-8  p-3 flex flex-col justify-between">
          <div className="mx-4">
            <p className="text-gray-400 mb-6">Update inventory</p>
            <p className="text-gray-100 mb-6">
              Last updated at {timeConverter(Date.now())}
            </p>
          </div>
          <div className="w-full flex justify-end items-end">
            <Button
              variant="contained"
              sx={{ backgroundColor: '' }}
              endIcon={<FaSave />}
              onClick={uploadFile}
            >
              Update
            </Button>
          </div>
        </div> */}
      </div>

      {currentVendor?.name && selColumns?.SKU && selColumns?.Quantity && (
        <div className="mt-8 h-[425px]">
          <h3 className="text-gray-400 my-2">
            Products for {currentVendor?.name}
          </h3>
          <DataGrid
            rows={csvData}
            columns={columns}
            pageSize={6}
            getRowId={(row) => row[selColumns?.SKU] + row[selColumns?.Quantity]}
            style={{ zIndex: 0 }}
            rowsPerPageOptions={[5]}
            sx={{
              color: 'white',
              '.MuiTablePagination-toolbar': { color: 'white' },
              '.MuiIconButton-root': { color: 'white' },
            }}
            disableSelectionOnClick
          />
        </div>
      )}
    </div>
  );
}

export default InventoryScreen;
